import React, { useEffect, useRef, useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faEraser } from "@fortawesome/free-solid-svg-icons";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo9/mapapoderes.png";
import GuiaDocente from "../../../components/GuiaDocente";
import { ReactSketchCanvas } from "react-sketch-canvas";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 2.mp3";

const styles = {
  height: "768px",
  background: `url(${Imagen1})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
};

const Actividad2 = () => {
  const [eraseMode, setEraseMode] = useState(false);
  const [penMode, setPenMode] = useState(true);
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[1];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo9.content[0].activities[2].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[2].path}`,
    titlePrev: `${modulo9.content[0].activities[0].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[0].path}`,
  };

  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };

  const canvasEl = useRef(null);
  const activateEraser = () => {
    setEraseMode(!eraseMode);
    setPenMode(eraseMode);
  };
  const activatePen = () => {
    setPenMode(!penMode);
    setEraseMode(penMode);
  };
  useEffect(() => {
    if (eraseMode) {
      canvasEl.current.eraseMode(true);
    } else {
      canvasEl.current.eraseMode(false);
    }
  }, [eraseMode]);
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <div className="row">
        <div className="col-md-10 col-sm-12 mb-1">
          <ul className="mb-5">
            <li>
              Las personas que trabajan en el Estado se llaman funcionarios o
              funcionarias. Ayúdalos a ir donde les corresponde.{" "}
            </li>
          </ul>
        </div>
      </div>

      <div className="row p-4 ms-md-3 text-center">
        <div className="col-md-3">
          <h4>Poder Judicial</h4>
        </div>
        <div className="col-md-3">
          <h4>Poder Ejecutivo</h4>
        </div>
        <div className="col-md-4">
          <h4>Poder Legislativo</h4>
        </div>
      </div>
      <div className="row ms-md-3">
        <div className="col-md-10 col-12 px-5">
          <ReactSketchCanvas
            ref={canvasEl}
            style={styles}
            width="600"
            height="100%"
            strokeWidth={4}
            strokeColor="red"
          />
        </div>
        <div className="col-md-10 col-12 px-5">
          <div className="d-flex justify-content-between px-3">
            <div>Congresista</div>
            <div>Jueza</div>
            <div>Vicepresidente</div>
            <div>Presidenta</div>
            <div>Congresista</div>
          </div>
        </div>
        <div className="col-md-10 col-12 px-5">
          <div className="d-flex mt-1 justify-content-end w-100">
            <button
              onClick={activateEraser}
              className={`btn btn-green me-1 ${
                eraseMode ? "active" : "inactive"
              }`}
            >
              Borrador <FontAwesomeIcon icon={faEraser} />
            </button>
            <button
              onClick={activatePen}
              className={`btn btn-green me-1 ${
                penMode ? "active" : "inactive"
              }`}
            >
              Lapiz <FontAwesomeIcon icon={faPen} />
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Aclare que hay que trazar en el mapa el camino
          que cada funcionario debe seguir para llegar al Poder que le
          corresponde. Los dos congresistas van al Poder Legislativo; la jueza
          va al Poder Judicial; el vicepresidente y la presidenta van al Poder
          Ejecutivo. Destaque los distintivos de cada cargo (banda, medalla).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad2;
